import React, { Component } from 'react';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/esm/FormControl';
import "./VehicleFilterSearch.css"

interface VehicleFilterSearchProps {
    input: string,
    placeholder: string,
    handleFilter: any,
    clearForm: any,
    toggleAdvancedSearch: any
}

class VehicleFilterSearch extends Component<VehicleFilterSearchProps>{

    render() {

        return (
            <div className="VehicleFilterSearch" id="vehicle-search-wrapper">
                <InputGroup className="mb-3">
                    <div className="VehicleSearchClear">
                        {this.props.input.length > 0 && <InputGroup.Prepend>
                            <InputGroup.Text id="basic-addon1" onClick={this.props.clearForm}><span className="material-icons">close</span></InputGroup.Text>
                        </InputGroup.Prepend>}
                    </div>
                    <div className="VehicleSearchSearch" id="vehicle-search-search">
                        {this.props.input.length === 0 && <InputGroup.Prepend>
                            <InputGroup.Text id="basic-addon1"><span className="material-icons">search</span>
                            </InputGroup.Text>
                        </InputGroup.Prepend>}
                    </div>
                    <FormControl /*onClick={() => this.props.toggleAdvancedSearch('off')}*/
                        placeholder={this.props.placeholder}
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        onChange={this.props.handleFilter}
                        value={this.props.input}
                    />
                </InputGroup>
            </div>
        )
    }
}

export default VehicleFilterSearch